let tabArray = document.querySelectorAll('[data-tabs]');
if (tabArray) {
    tabArray.forEach(tab => {
        let tabBtnArray = tab.querySelectorAll('[data-tabs-header-button]');
        let tabCntArray = tab.querySelectorAll('[data-tabs-item]');
        if (tabBtnArray) {
            tabBtnArray[0].classList.add('active');
        }

        tabCntArray.forEach((item) => {
            item.classList.add('visually-hidden');
        })

        if (tabCntArray) {
            tabCntArray[0].classList.remove('visually-hidden');
        }
    })
}

let tabButtonsArray = document.querySelectorAll('[data-tabs-header-button]');
if (tabButtonsArray) {
    tabButtonsArray.forEach((tabButton) => {
        tabButton.addEventListener('click', () => {
            let tabButtonId = tabButton.dataset.tabTitle;

            let currentTabsBLock = tabButton.closest('[data-tabs]');
            let tabButtonArray = currentTabsBLock.querySelectorAll('[data-tabs-header-button]');
            tabButtonArray.forEach((button) => {
                if (button.dataset.tabTitle == tabButtonId) {
                    button.classList.add('active');
                } else {
                    if (button.classList.contains('active')) {
                        button.classList.remove('active');
                    }
                }
            })

            let tabContentArray = currentTabsBLock.querySelectorAll('[data-tabs-item]');
            tabContentArray.forEach((tab) => {
                if (tab.dataset.tabContent == tabButtonId) {
                    tab.classList.remove('visually-hidden');
                } else {
                    if (!tab.classList.contains('visually-hidden')) {
                        tab.classList.add('visually-hidden');
                    }
                }
            })
        })
    })
}
